// Tier 5 (QUANTITATIVE TRADING) — 30 lessons across modules 5.1–5.6.
// Final and most advanced tier of the FLEXX Academy curriculum.
// Static imports → PWA bundles lesson data at build time (zero network calls, works offline).
import lessonsT5_1to2 from "./axel-lessons-5.1.1-to-5.2.5.json";
import lessonsT5_3to6 from "./axel-lessons-5.3.1-to-5.6.5.json";
import { normalizeLesson } from "./normalizeQuiz";

const unwrap = (src) => (Array.isArray(src) ? src : src?.lessons || []);

export const TIER5_LESSONS = [
  ...unwrap(lessonsT5_1to2),
  ...unwrap(lessonsT5_3to6),
]
  .map(normalizeLesson)
  .sort((a, b) => (a.id || "").localeCompare(b.id || "", undefined, { numeric: true }));
